const REAL_ESTATE_DATA = [
	'flat|projectEstate',
	'house',
	'flat|house|projectEstate',
	'parcel',
	'garage',
	'projectEstate',
	'office',
	'shop',
	'tourism',
	'industrial',
	'agricultural',
	'parcelForInnovation',
	'publicInstitution'
];

const FLOOR_VALUES = [
	'underground4',
	'underground3',
	'underground2',
	'underground1',
	'basement',
	'suteren',
	'halfSuteren',
	'downstairs',
	'highDownstairs',
	'halfUpstairs',
	'1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '10+'
];
const LIVING_ROOM_ORIENTATIONS = {
	north: 'North',
	northeast: 'NorthEast',
	east: 'East',
	southeast: 'SouthEast',
	south: 'South',
	southwest: 'SouthWest',
	west: 'West',
	northwest: 'NorthWest'
};
const SALE_VALUES = ['toSell', 'toRent'];
const RANGE_SEPARATOR = '~';
const PROPERTIES_SEPARATOR = '|';
const DEFAULT_PAGE = 0;
const DEFAULT_PAGE_SIZE = 10;
// const PAGE_SIZE = 200;
const DEFAULT_ORDER = 'orderBy=createDateTime&orderDirection=desc';

export class SearchService {
	constructor($http, $q, $timeout) {
		'ngInject';
		this.$http = $http;
		this.$q = $q;
		this.$timeout = $timeout;
		this.publicRoot = '/public';
		this.privateRoot = '/private';
	}

	searchProperty(params) {
		return this.$http({
			method: 'GET',
			url: `${this.publicRoot}/properties/search`,
			params: params
		});
	}

	getRealEstateSearchResults(data) {
		// data.pageSize = PAGE_SIZE;
		let transformedData = this.transformFormData(data);
		return this.$http.get(this.publicRoot + '/properties/search' + encodeURI(transformedData) + '&_=' + new Date().getTime());
	}

	transformFormData(data) {
		let resultQuery = '?';
		data = this.fillFLoorIfNotExists(data);
		resultQuery += this.transformComissionType(data);
		resultQuery += this.transformNumericRange(data, 'arMinimum', 'arMaximum', 'priceHuf', data.ertekesitestipusa == '1' ? 'k' : 'm');
		resultQuery += this.transformNumericRange(data, 'meretMinimum', 'meretMaximum', 'area', '');
		resultQuery += this.transformNumericRange(data, 'innerHeightMin', 'innerHeightMax', 'innerHeight', '', 0, '');
		resultQuery += this.transformNumericRange(data, 'floorsInBuildingMin', 'floorsInBuildingMax', 'floorsInBuilding', '', 1, 10);
		resultQuery += this.transformIntegerRange(data, 'roomsMin', 'roomsMax', 'numberOfAllRooms', '', 0, '');
		resultQuery += this.transformNumericRange(data, 'bathroomsMin', 'bathroomsMax', 'numberOfBathrooms', '', 0, '');
		resultQuery += this.transformLocation(data);
		resultQuery += this.transformLocationTypes(data);
		resultQuery += this.transformPaging(data);
		resultQuery += this.transformOrderBy(data);
		resultQuery += this.transformLivingRoomOrientation(data);
		resultQuery += this.transformArrayAndValues(data.conditionOfProperty, 'conditionOfProperty', PROPERTIES_SEPARATOR);
		resultQuery += this.transformArrayAndValues(data.heating, 'heating', PROPERTIES_SEPARATOR);
		resultQuery += this.transformArrayAndValues(data.buildingStructure, 'buildingStructure', PROPERTIES_SEPARATOR);
		resultQuery += this.transformArrayAndValues(data.elevator, 'elevator', PROPERTIES_SEPARATOR);
		resultQuery += this.transformArrayAndValues(data.comfortLevel, 'comfortLevel', PROPERTIES_SEPARATOR);
		// resultQuery += this.transformArrayAndValues(data.miscellaneous, 'miscellaneous', PROPERTIES_SEPARATOR);
		resultQuery += this.transformArrayAndValues(data.parkingOption, 'parkingOption', PROPERTIES_SEPARATOR);
		resultQuery += this.transformArrayAndValues(data.view, 'view', PROPERTIES_SEPARATOR);
		resultQuery += this.transformArrayAndValues(data.staircaseType, 'staircaseType', PROPERTIES_SEPARATOR);
		resultQuery += this.transformArrayAndValues(data.floor, 'floor', PROPERTIES_SEPARATOR, 'underground4', '10+');
		resultQuery += this.transformArrayAndValues(data['rooms.type'], 'rooms.type', PROPERTIES_SEPARATOR);
		resultQuery += this.transformSingleValue(data.keyWord, 'description');
		resultQuery += this.transformSingleValue(data['project.id'], 'project.id');
		resultQuery += this.transformSingleValue(data.isOwnedByFactoring, 'isOwnedByFactoring');
		resultQuery += this.transformSingleValue(data.isInAttic, 'isInAttic');
		resultQuery += this.transformSingleValue(data.hasGardenOrPark, 'hasGardenOrPark');
		resultQuery += this.transformSingleValue(data.hasPoolOrSwimmingPool, 'hasPoolOrSwimmingPool');
		resultQuery += this.transformSingleValue(data.comissionId, 'comissionId');

		return resultQuery;
	}

	fillFLoorIfNotExists(data) {
		let localData = angular.copy(data);
		if (!localData.floor) {
			localData.floor = [];
			for (let i = data.floorMin; i <= data.floorMax; i++) {
				localData.floor.push(FLOOR_VALUES[i]);
			}
		}
		return localData;
	}

	transformSingleValue(data, key) {
		return data ? '&' + key + '=' + data : '';
	}

	transformComissionType(data) {
		let result = '';
		if (Number.isInteger(data.ingatlantipusa)) {
			result += this.transformType(data);
		}
		if (data.ertekesitestipusa && typeof SALE_VALUES[data.ertekesitestipusa] != 'undefined') {
			result += '&comissionType=' + SALE_VALUES[data.ertekesitestipusa];
		}
		return result;
	}

	transformOrderBy(data) {
		return data.order && data.order != DEFAULT_ORDER ? '&' + data.order : '';
	}

	transformPaging(data) {
		let result = '';
		if (Number.isInteger(data.page) && data.page != DEFAULT_PAGE || Array.isArray(data.page) && data.page.length && data.page[0] != DEFAULT_PAGE) {
			result += '&page=' + data.page;
		}
		if (data.pageSize && data.pageSize != DEFAULT_PAGE_SIZE) {
			result += '&pageSize=' + data.pageSize;
		}
		return result;
	}

	transformType(data) {
		let result = '';
		// ilyen elvileg már nem lehet
		if (Array.isArray(data.ingatlantipusa)) {
			result = '&type=' + REAL_ESTATE_DATA[data.ingatlantipusa[0]];
		} else if (Number.isInteger(data.ingatlantipusa)) {
			result = '&type=' + REAL_ESTATE_DATA[data.ingatlantipusa];
		}
		return result;
	}

	transformNumericRange(data, lowerProperty, higherProperty, key, multiplier, defaultLow, defaultHigh) {
		let result = '';
		if (data[lowerProperty] === defaultLow && data[higherProperty] === defaultHigh) {
			return '';
		}
		if (data[lowerProperty] || data[lowerProperty] === 0) {
			result += '&' + key + '=' + data[lowerProperty] + multiplier + RANGE_SEPARATOR;
		} else {
			result += '&' + key + '=' + RANGE_SEPARATOR;
		}
		if (data[higherProperty] || data[higherProperty] === 0) {
			result += data[higherProperty] + multiplier;
		}
		return result == '&' + key + '=' + multiplier +  RANGE_SEPARATOR + multiplier ||
			result == '&' + key + '=' + RANGE_SEPARATOR ?
			'' :
			result;
	}
	transformIntegerRange(data, lowerProperty, higherProperty, key, multiplier, defaultLow, defaultHigh) {
		let result = '';
		if (data[lowerProperty] === defaultLow && data[higherProperty] === defaultHigh) {
			return '';
		}
		if (data[lowerProperty] || data[lowerProperty] === 0) {
			result += '&' + key + '=' + Math.ceil(data[lowerProperty]) + multiplier + RANGE_SEPARATOR;
		} else {
			result += '&' + key + '=' + RANGE_SEPARATOR;
		}
		if (data[higherProperty] || data[higherProperty] === 0) {
			result += Math.ceil(data[higherProperty]) + multiplier;
		}
		return result == '&' + key + '=' + multiplier +  RANGE_SEPARATOR + multiplier ||
			result == '&' + key + '=' + RANGE_SEPARATOR ?
			'' :
			result;
	}
	transformLocation(data) {
		let result = '';
		if (data.selectedTags && data.selectedTags.length) {
			result += '&location=';
			for (let i = 0; i < data.selectedTags.length; ++i) {
				result += data.selectedTags[i];
				if (i != data.selectedTags.length - 1) {
					result += PROPERTIES_SEPARATOR;
				}
			}
		}
		if (data.location) {
			if (result != '') {
				result += PROPERTIES_SEPARATOR + data.location;
			} else {
				result += '&location=' + data.location;
			}
		}
		return result;
	}

	transformLocationTypes(data) {
		let result = '';
		if (data.locationTypes && data.locationTypes.length) {
			result += '&locationTypes=';
			for (let i = 0; i < data.locationTypes.length; ++i) {
				result += data.locationTypes[i];
				if (i != data.locationTypes.length - 1) {
					result += PROPERTIES_SEPARATOR;
				}
			}
		}
		return result;
	}
	transformLivingRoomOrientation(data) {
		let result = '';
		if (data.livingRoomOrientation && data.livingRoomOrientation.length) {
			result += '&livingRoomOrientation=';
			for (let i = 0; i < data.livingRoomOrientation.length; ++i) {
				result += LIVING_ROOM_ORIENTATIONS[data.livingRoomOrientation[i]];
				if (i != data.livingRoomOrientation.length - 1) {
					result += PROPERTIES_SEPARATOR;
				}
			}
		}
		return result;
	}

	transformArrayAndValues(dataArray, keyName, separator, defaultMin, defaultMax) {
		let result = '';
		if (dataArray && dataArray.length) {
			if (defaultMin && dataArray[0] == defaultMin && dataArray[dataArray.length - 1] == defaultMax) {
				return result;
			} else {
				result += '&' + keyName + '=';
				result += dataArray.join(separator);
			}
		}
		return result;
	}

	getFreeGeoIp() {
		return this.$http.get(`${this.publicRoot}/location/geoip`);
	}
}
